import axios from 'axios'

const state = {
    myReferrals: null,
    acctCounter: null,
    myFollowers: null,
    myFollowing: null,
    myBlockedList: null,
}

const getters = {
    myReferrals (state) {
        return state.myReferrals
    },
    acctCounter (state) {
        return state.acctCounter
    },
    myFollowers (state) {
        return state.myFollowers
    },
    myFollowing (state) {
        return state.myFollowing
    },
    myBlockedList (state) {
        return state.myBlockedList
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    async myAccountCounter({ commit }, userObj) {
        let response = null
        // only use token if the person is looking up other users without signing in
        if(userObj.token){
            response = await axios.post(`/counts/accountCounter`, userObj, {
                headers: {
                    'Authorization': `Bearer ${userObj.token}`
                }
            })
        } else {
            response = await axios.post(`/counts/accountCounter`, userObj)
        }
        if(!response.data.error){
            commit('ACCT_COUNTER', response.data.result)
        }
    },

    async addFollower({ dispatch, getters }, userObj) {
        let response = await axios.post(`/relationship/follow`, userObj)
        if(!response.data.error){
            let lookupUserObj = { userId: getters.lookupUser._id }
            dispatch('myAccountCounter', lookupUserObj)
            dispatch('fetchRelationships', lookupUserObj)
        }
    },
    
    async removeFollower({ dispatch, getters }, userObj) {
        let response = await axios.post(`/relationship/unfollow`, userObj)
        if(!response.data.error){
            let lookupUserObj = { userId: getters.lookupUser._id }
            dispatch('myAccountCounter', lookupUserObj)
            dispatch('fetchRelationships', lookupUserObj)
        }
    },

    async blockUser({ dispatch }, userObj) {
        let response = await axios.post(`/relationship/block`, userObj)
        if(!response.data.error){
            dispatch('fetchConnections', userObj)
        }
    },
    
    async unblockUser({ dispatch }, userObj) {
        let response = await axios.post(`/relationship/unblock`, userObj)
        if(!response.data.error){
            dispatch('fetchConnections', userObj)
        }
    },
    
    // fetches loggedIn or lookedUp user following and followers
    async fetchRelationships({ commit }, userObj) {
        let response = await axios.post(`/relationship/fetchRelations`, userObj)
        if(!response.data.error){
            commit('SET_FOLLOWERS', response.data.result.followers)
            commit('SET_FOLLOWING', response.data.result.following)
        }
    },
    
    // fetches loggedIn blocked and referred users
    async fetchConnections({ commit }, userObj) {
        let response = await axios.post(`/relationship/fetchConnectedUsers`, userObj)
        if(!response.data.error){
            commit('SET_BLOCKED', response.data.result.blocked)
            commit('SET_REFERRALS', response.data.result.referrals)
        }
    },

}

const mutations = {
    ACCT_COUNTER: (state, acctCounter) => (state.acctCounter = acctCounter),
    SET_FOLLOWERS: (state, myFollowers) => (state.myFollowers = myFollowers),
    SET_FOLLOWING: (state, myFollowing) => (state.myFollowing = myFollowing),
    SET_REFERRALS: (state, myReferrals) => (state.myReferrals = myReferrals),
    SET_BLOCKED: (state, myBlockedList) => (state.myBlockedList = myBlockedList),
}

export default {
    state,
    getters,
    actions,
    mutations
}